import { useIntl } from 'react-intl';
import { Modal } from 'antd';

import { PAGES_TEMPLATES_OPTIONS_KEYS } from 'constants/page-templates';

import { ReactComponent as RightIcon } from 'assets/bosta-icons/Chevron-right.svg';

import './PagesTemplatesModal.less';

const PagesTemplatesModal = ({ close, setSelectedTemplateKey, ...props }) => {
  const { formatMessage } = useIntl();

  const selectTemplate = (key) => {
    setSelectedTemplateKey(key);
    close();
  };

  return (
    <Modal
      {...props}
      title={formatMessage({
        id: 'pages.create_edit_page.create_from_template.modal.title'
      })}
      onCancel={close}
      footer={null}
    >
      {PAGES_TEMPLATES_OPTIONS_KEYS.map((key) => (
        <div
          key={key}
          className="br-pages-templates-modal__template"
          onClick={() => selectTemplate(key)}
        >
          <div className="br-pages-templates-modal__template__text">
            <span className="body-medium">
              {formatMessage({
                id: `pages.create_edit_page.create_from_template.modal.templates.${key}.title`
              })}
            </span>
            <span className="br-pages-templates-modal__template__subtitle">
              {formatMessage({
                id: `pages.create_edit_page.create_from_template.modal.templates.${key}.subtitle`
              })}
            </span>
          </div>
          <RightIcon className="right-icon" />
        </div>
      ))}
    </Modal>
  );
};

export default PagesTemplatesModal;
